"use client";

import { usePathname } from "next/navigation";

export default function HeaderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  // Hide header on auth pages
  const authPages = ["/login", "/forgot-password", "/login-otp"];
  if (authPages.includes(pathname)) {
    return null;
  }

  // Hide header on portal pages that have their own navigation
  const portalPages = [
    "/superadmin",
    "/booking",
    "/barstaff",
    "/customerportal",
  ];
  if (portalPages.some((portal) => pathname.startsWith(portal))) {
    return null;
  }

  return <>{children}</>;
}
